import { useStaticQuery, graphql } from 'gatsby';

export const useSiteMetadata = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            url
            shortTitle
            shortDescription
            locales {
              default
            }
          }
        }
        favicon16: file(name: { eq: "favicon" }) {
          childImageSharp {
            resize(width: 16) {
              src
              width
              height
            }
          }
        }
        favicon32: file(name: { eq: "favicon" }) {
          childImageSharp {
            resize(width: 32) {
              src
              width
              height
            }
          }
        }
        favicon64: file(name: { eq: "favicon" }) {
          childImageSharp {
            resize(width: 64) {
              src
              width
              height
            }
          }
        }
        thumbnail: file(name: { eq: "thumbnail" }) {
          childImageSharp {
            gatsbyImageData(layout: FIXED, placeholder: BLURRED)
          }
        }
      }
    `
  );

  // gatsby image queries

  return {
    ...data.site.siteMetadata,
    thumbnail: data.thumbnail?.childImageSharp.gatsbyImageData ?? null,
    favicon16: data.favicon16?.childImageSharp.resize ?? null,
    favicon32: data.favicon32?.childImageSharp.resize ?? null,
    favicon64: data.favicon64?.childImageSharp.resize ?? null
  };
};
